import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-scrollable.css';
import { UitkScrollableTags } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkScrollable = function (props) {
  var tag = props.tag,
    _a = props.direction,
    direction = _a === void 0 ? 'horizontal' : _a,
    className = props.className,
    children = props.children;
  var baseCssClass = 'uitk-scrollable';
  var cssClassNames = getClassNameList(className, baseCssClass, "".concat(baseCssClass, "-").concat(direction));
  var scrollableRef = React.useRef(null);
  var _b = React.useState(0),
    mouseStartPos = _b[0],
    setMouseStartPos = _b[1];
  var _c = React.useState(0),
    scrollStartPos = _c[0],
    setScrollStartPos = _c[1];
  var _d = React.useState(false),
    isDragging = _d[0],
    setIsDragging = _d[1];
  var handleMouseDown = function (e) {
    setIsDragging(true);
    setScrollStartPos(scrollableRef.current.scrollLeft);
    setMouseStartPos(e.pageX);
  };
  var handleMouseEnter = function (e) {
    if (isDragging) handleMouseDown(e);
  };
  var handleMouseUp = function () {
    return setIsDragging(false);
  };
  var handleMouseMove = function (e) {
    if (isDragging) scrollableRef.current.scrollLeft = scrollStartPos - (e.pageX - mouseStartPos);
  };
  React.useEffect(function () {
    if (isDragging) document.addEventListener('mouseup', handleMouseUp);
    return function () {
      return document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);
  var horizontalProps;
  if (direction === 'horizontal') {
    horizontalProps = {
      onMouseEnter: handleMouseEnter,
      onMouseMove: handleMouseMove,
      onMouseDown: handleMouseDown,
      ref: scrollableRef
    };
  }
  // Renders the custom Tag
  var Tag = tag && UitkScrollableTags.includes(tag) ? tag : 'div';
  return React.createElement(Tag, __assign({
    tabIndex: 0,
    role: "group",
    className: cssClassNames
  }, horizontalProps), children);
};
UitkScrollable.displayName = 'UitkScrollable';
export { UitkScrollable };